module.exports = __webpack_public_path__ + "img/cmg-labs-3.3c880435.jpg";